(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boutique-product-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const link=event.target.closest('a[href="#boutique-size-guide"]');
  if(link){document.getElementById('boutique-size-guide')?.setAttribute('open','');}
});
if(location.hash==='#boutique-size-guide'){document.getElementById('boutique-size-guide')?.setAttribute('open','');}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
